import BaseCheckBox from "Engine/base/ui/BaseCheckBox";

export default class BaseAutoPlaySelectButton extends BaseCheckBox {
    constructor(data, displayData) {
        super(data, displayData);

        this.id = 0;
        this._value = 0;
    }

    init() {
        super.init();
        this.id = +this.name.replace('count_', '');
    }

    onClick() {
        this.checked = !this.checked;
        let actionData = this.actions[this.checked ? 'checked' : 'unchecked'];
        if (actionData) {
            if (actionData.callback) {
                actionData.callback.call(actionData.context, actionData.params);
            }
        }
    }

    goToFrame(frameId, force = true) {
        super.goToFrame(frameId, force);
        this.valueText = this.getChildByName('valueText');
        this.valueText.text = this.value;
    }

    get value() {
        return this._value;
    }

    set value(value) {
        this._value = value;
        this.valueText.text = this.value;
    }
}